import {Component, HostListener, OnInit, ViewEncapsulation} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import {ActivatedRoute, Router} from "@angular/router";
import {AccountService, AlertService} from "../services";
import {first} from "rxjs/operators";
import {FuseNavigationService} from "../../../@fuse/components/navigation/navigation.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {CardOnlineService} from "../services/cardOnline.service";

@Component({
    selector     : 'login',
    templateUrl  : './login.component.html',
    styleUrls    : ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class LoginComponent implements OnInit
{
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    codeScanner = [];
    lastKeyup: any;
    isNotOnlineError = false;

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private accountService: AccountService,
        private _fuseNavigationService: FuseNavigationService,
        private translationLoader: FuseTranslationLoaderService,
        private cardOnlineService: CardOnlineService,
    )
    {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

        this.translationLoader.loadTranslations(polish, english);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.loginForm = this._formBuilder.group({
            username: ['', [Validators.required]],
            password: ['', Validators.required]
        });
    }

    get f() { return this.loginForm.controls; }

    @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.key != 'Enter' && event.key != ' ') {

            if (typeof this.lastKeyup !== "undefined" && ((new Date()).getTime() - this.lastKeyup)>250) {
                this.codeScanner = [];
            }

            this.codeScanner.push(event.key);
        } else if (event.key == 'Enter' && this.codeScanner.length > 4) {
            this.loading = true;
            this.isNotOnlineError = false;

            this.cardOnlineService.isOnline(this.codeScanner.join(''))
                .pipe(first())
                .subscribe(
                    data => {
                        this.accountService.loginByCard(this.codeScanner.join(''))
                            .pipe(first())
                            .subscribe(
                                data => {
                                    this.codeScanner = [];
                                },
                                error => {
                                    this.codeScanner = [];
                                    this.loading = false;
                                });
                        this.codeScanner = [];
                    }, error => {
                        this.codeScanner = [];
                        this.loading = false;
                        this.isNotOnlineError = true;
                    });
        }
    }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.isNotOnlineError = false;
        this.cardOnlineService.isOnline(this.f.username.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.accountService.login(this.f.username.value, this.f.password.value)
                        .pipe(first())
                        .subscribe(
                            data => {

                            },
                            error => {
                                this.loading = false;
                            });
                }, error => {
                    this.loading = false;
                    this.isNotOnlineError = true;
                });
    }
}
